import { gql } from '@apollo/client';
import { DealItemFragment } from './DealItemFragment';
import { DealClientFragment } from './DealClientFragment';
import { DealContactFragment } from './DealContactFragment';
import { CurrencyFragment } from 'graphql/Currency/fragments/CurrencyFragment';
import { LocationFragment } from 'graphql/Location/fragments/LocationFragment';
import { DealOtherFeeFragment } from './DealOtherFeeFragment';
import { ConfigurationFieldFragment } from 'graphql/ConfigurationField/fragments/ConfigurationFieldFragment';
import { FieldValueFragment } from 'graphql/FieldValue/fragments/FieldValueFragment';
import { RefusalReasonFragment } from 'graphql/RefusalReason/fragments/RefusalReasonFragment';
/**
 * @fragment DealDetailsFragment
 * @since 1.0.0
 */
export const DealDetailsFragment = gql `
  fragment DealDetailsFragment on Deal {
    id

    date
    title
    headline
    introduction
    termsAndConditions
    type
    number
    draft
    status
    stage
    internalNotes
    notes
    showIncludedOptions
    subtotal
    total
    discount
    discountType
    language
    createdAt
    updatedAt
    orderIn
    externalData
    priceDisplay
    plannedDateStart
    plannedDateEnd
    refusalReasonId

    refusalReason {
      ...RefusalReasonFragment
    }
    fieldValues {
      ...FieldValueFragment
    }

    user {
      id
      firstname
      lastname
      email
      fullname
      account {
        id
        name
        civicNumber
        road
        city
        province
        country
        postalcode
        logo {
          url
        }
      }
      contact {
        id
        title
        client {
          image {
            url
          }
        }
      }
      image {
        url
      }
    }

    client {
      ...DealClientFragment
    }

    contact {
      ...DealContactFragment
    }

    billTo {
      ...LocationFragment
    }

    shipTo {
      ...LocationFragment
    }

    currency {
      ...CurrencyFragment
    }

    items {
      ...DealItemFragment
    }

    otherFees {
      ...DealOtherFeeFragment
    }

    payments {
      id
      date
      description
      status
      amount
      percent
      isDeposit
      infos
    }

    orders {
      id
      date
      status
      stage
      number
      total
      createdAt
      updatedAt

      items {
        id
        type
        quantity
        price
        title
        item {
          title
        }
      }
    }

    taskList {
      id
      number

      order {
        id
      }

      tasks {
        id
        quantity
        price
        title
        status

        dealItem {
          id

          item {
            id
            title
            summary
            infos
            sku
            price
            cost
          }

          fieldValues {
            ...FieldValueFragment
          }
        }

        dealItemConfiguration {
          id
          type
          parent

          item {
            id
            title
            summary
            infos
            sku
            price
            cost
          }

          package {
            id
            title
          }

          fieldValues {
            ...FieldValueFragment
          }
        }

        saleItem {
          id
          title
          infos
          summary
          sku
          price
          cost
          trackQuantity

          group {
            id
            title
          }
        }

        fieldValues {
          field {
            id
            name
            title
            infos
            promote
            visibility
            group {
              id
              category
            }
          }
          value
        }
      }

      approbations {
        state
        firstName
        lastName
        email
        date
        signatureBase64
        createdAt
      }
    }

    approbations {
      state
      firstName
      lastName
      email
      date
      signatureBase64
      createdAt
      user {
        id
        fullname
      }
    }

    configurationFields {
      ...ConfigurationFieldFragment
    }

    translations {
      headline
      introduction
      termsAndConditions
      language {
        id
        name
        code
      }
    }
  }

  ${FieldValueFragment}
  ${DealClientFragment}
  ${DealContactFragment}
  ${LocationFragment}
  ${CurrencyFragment}
  ${DealItemFragment}
  ${DealOtherFeeFragment}
  ${ConfigurationFieldFragment}
  ${RefusalReasonFragment}
`;
